import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import history from '../history';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from 'Store/actions';

const pageStyles = (theme) => ({
  productInformation: {
    paddingLeft: '50px',
  },
  productCheckbox: {
    marginRight: '17px',
    marginLeft: '-50px',
  },
  productDescription: {
    fontFamily: "'Work Sans', sans-serif",
    fontSize: '16px',
    lineHeight: '23px',
    marginTop: 0,
  },
  image: {
    maxHeight: '143px',
  },
  productPrice: {
    color: '#45A358',
    fontWeight: 900,
  },
  productQuantityContainer: {
    '& .MuiFormLabel-root': {
      fontSize: '16px',
    },
    '& .MuiSvgIcon-root': {
      width: '23px',
    },
    '& .MuiSelect-root': {
      fontSize: '16px',
      lineHeight: '1.5',
    },
  },
  productQuantitySelect: {
    width: 55,
    marginBottom: 50,
  },
});

const ItemReviewProduct = ({
  item,
  className,
  classes,
  saveItemDraftOrder,
}) => {
  const priceWithShipping = (
    parseFloat(item.price, 10) + parseFloat(item.shipping, 10)
  ).toFixed(2);
  return (
    <div className={className}>
      <p>{item.label}</p>
      <p className={classes.productPrice}>{`$${priceWithShipping}`}</p>
      <img
        className={classes.image}
        src={item.imageUrl}
        srcSet={`${item.imageUrl2x} 2x, ${item.imageUrl3x} 3x`}
        alt={item.imageAltText}
      />
      <p className={classes.productDescription}>
        {item.numTags > 1 && `${item.numTags}x stickers`}
        <br />
        {item.dimensions}
      </p>
      <Button
        variant="contained"
        size="large"
        color="primary"
        onClick={() => {
          saveItemDraftOrder([{ typeId: item.productId, quantity: 1 }]);
          history.push('/add-item');
        }}
      >
        Select
      </Button>
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      saveItemDraftOrder: actions.saveItemDraftOrder,
    },
    dispatch,
  );
}

export default connect(
  null,
  mapDispatchToProps,
)(withStyles(pageStyles)(ItemReviewProduct));
